import Select, { Option as OptionImported } from './Select';

export type Option = OptionImported;
export default Select;
